import * as THREE from 'three'

class CameraController {
  constructor(camera, options = {}) {
    this.camera = camera
    this.moveSpeed = options.moveSpeed || 1
    this.rotationSpeed = options.rotationSpeed || Math.PI * 0.2
    this.keysPressed = {}
    this.mouse = { x: 0, y: 0 }
    this.camera.rotation.order = 'YXZ'; // IMPORTANT

    // targets for smooth interpolation
    this.targetYaw = 0
    this.targetPitch = 0
    // limits
    this.maxYaw = Math.PI * 0.7
    this.maxPitch = Math.PI / 6

    this.dir = new THREE.Vector3();
    this.tmpTarget = new THREE.Vector3();

    this.bounds = options.bounds || {
      // minX: -Infinity, maxX: Infinity,
      // minZ: -Infinity, maxZ: Infinity
      minX: 20.75, maxX: 21+0.75,
      minZ: 23-0.75, maxZ: 23.25
    }
    

    this.setupControls()
  }

  setupControls() {
    window.addEventListener('keydown', (event) => {
      const key = event.key.toLowerCase()
      this.keysPressed[key] = true

      if (['w', 'a', 's', 'd', 'arrowup', 'arrowdown', 'arrowleft', 'arrowright'].includes(key)) {
        event.preventDefault()
      }
    })

    window.addEventListener('keyup', (event) => {
      const key = event.key.toLowerCase()
      delete this.keysPressed[key]
    })

    window.addEventListener('pointermove', (event) => {
      this.mouse.x = (event.clientX / window.innerWidth  - 0.5) * 2;
      this.mouse.y = (event.clientY / window.innerHeight - 0.5) * 2;
    })
  }

  update(delta) {
    const actualMoveSpeed = this.moveSpeed * delta
    const actualRotationSpeed = this.rotationSpeed * delta
    const velocity = new THREE.Vector3(0, 0, 0)

    if (this.keysPressed['w'] || this.keysPressed['arrowup']) velocity.z -= actualMoveSpeed
    if (this.keysPressed['s'] || this.keysPressed['arrowdown']) velocity.z += actualMoveSpeed
    if (this.keysPressed['a']) velocity.x -= actualMoveSpeed
    if (this.keysPressed['d']) velocity.x += actualMoveSpeed
    if (this.keysPressed['q']) velocity.y -= actualMoveSpeed
    if (this.keysPressed['e']) velocity.y += actualMoveSpeed

    this.camera.translateX(velocity.x)
    this.camera.translateZ(velocity.z)
    this.camera.translateY(velocity.y)

    if (this.keysPressed['arrowleft']) this.camera.rotation.y += actualRotationSpeed
    if (this.keysPressed['arrowright']) this.camera.rotation.y -= actualRotationSpeed

    this.camera.position.x = Math.max(this.bounds.minX, Math.min(this.bounds.maxX, this.camera.position.x))
    this.camera.position.z = Math.max(this.bounds.minZ, Math.min(this.bounds.maxZ, this.camera.position.z))
    this.camera.position.y = 11; // keep height constant

    this.targetYaw = THREE.MathUtils.clamp(-this.mouse.x * this.maxYaw, -this.maxYaw, this.maxYaw)

    const rawPitch = THREE.MathUtils.clamp(-this.mouse.y * this.maxPitch, -this.maxPitch, this.maxPitch)
    const levelFactor = Math.cos(this.targetYaw)
    this.targetPitch = rawPitch * levelFactor

    const yawDiff = this.targetYaw - this.camera.rotation.y
    this.camera.rotation.y += yawDiff * Math.min(1.0, 6.0 * delta)

    const pitchDiff = this.targetPitch - this.camera.rotation.x
    this.camera.rotation.x += pitchDiff * Math.min(1.0, 6.0 * delta)
    this.camera.rotation.z = 0
  }
}

export default CameraController;
